module.exports = __webpack_public_path__ + "img/1.81d74ce6.webp";